module.exports = __webpack_public_path__ + "img/archimed_curve.5c3a7bc0.png";